import {MappedComponentProperties} from "@adobe/aem-react-editable-components";
import React from "react";
import extractModelId from "../../utils/extract-model-id";
import LinkedInIcon from "../../ui.lib/assets/images/icons/linkedin.svg";
import FacebookIcon from "../../ui.lib/assets/images/icons/facebook.svg";
import TwitterXIcon from "../../ui.lib/assets/images/icons/twitter-x.svg";
import { AuthorSocialShare, AuthorSocialShareData } from "../../ui.lib/components/shared/author-social-share";


const AuthorAndSocialShareComponent = (props: MappedComponentProperties & {"data": any}) => {
  const {data} = props;
  const {authorSocialShare} = data;

  const CMS_AUTHORSOCIALSHARE_DATA: AuthorSocialShareData = {
    id: authorSocialShare?.id,
    backgroundColor: authorSocialShare?.backgroundColor,
    socialShare: authorSocialShare?.socialShare,
    socialShareLabel: authorSocialShare?.socialShareLabel,
    authorLine: authorSocialShare?.authorLine,
    publishedDate: authorSocialShare?.publishedDate,
    reduceWidth: authorSocialShare?.reduceWidth,
    reduceBottomSpacing: authorSocialShare?.reduceBottomSpacing,
    reduceTopSpacing: authorSocialShare?.reduceTopSpacing,
    socialShareLinks: [
      {
        socialIcon: LinkedInIcon,
        socialIconAlt: "LinkedIn logo",
        socialShareUrl: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
          window.location.href,
        )}`,
      },
      {
        socialIcon: FacebookIcon,
        socialIconAlt: "Facebook logo",
        socialShareUrl: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          window.location.href,
        )}`,
      },
      {
        socialIcon: TwitterXIcon,
        socialIconAlt: "X logo",
        socialShareUrl: `https://x.com/intent/tweet?url=${encodeURIComponent(
          window.location.href,
        )}`,
      },
    ]
  }


  console.log('CMS_AUTHORSOCIALSHARE_DATA', CMS_AUTHORSOCIALSHARE_DATA);

  return <div id={extractModelId(props.cqPath)}>
      <AuthorSocialShare data={CMS_AUTHORSOCIALSHARE_DATA} />
  </div>
};

export default AuthorAndSocialShareComponent;